import { useContext } from 'react';

import { config } from 'config';

import { ContentContext } from 'context/ContentContext';

import { HeroSection } from 'ui/molecules/HeroSection/HeroSection';

import { Topics } from 'features/articles/atoms/Topics/Topics';
import { Benefits } from 'features/articles/organisms/Benefits/Benefits';

const CustomersPage = () => {
  const { secondaryNavigation, data: content } = useContext(ContentContext);

  return (
    <div className="customers-page">
      <HeroSection
        description={content.description}
        title={content.title}
        buttonText={content.button_text}
        buttonHref={content.button_href}
        type="customers-page"
      />

      <Topics type="case_studies" />

      {secondaryNavigation.customers?.slug && (
        <Benefits
          withBlog
          hasPriortyFirstImage
          limit={config.articles.regularPerPage}
          route={secondaryNavigation.customers.slug}
        />
      )}
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default CustomersPage;
